// extracted by mini-css-extract-plugin
export default {"announcement-banner":"RootLayoutAdmin_announcement-banner__xi0ie"};